import {
  type CustomBehaviourValues,
  getOrgAddressesList,
  getOrgBasicInfo,
  type PersonAddress,
  type Position
} from 'services'

export const getAddressFromOrg = async (orgId: number): Promise<PersonAddress> => {
  try {
    const addresses = await getOrgAddressesList(orgId)

    if (addresses.length > 0) {
      return {
        phone: {
          addressId: null,
          countryCode: addresses[0].phone?.countryCode != null ? addresses[0].phone?.countryCode : '',
          id: null,
          phoneNumber: addresses[0].phone?.phoneNumber != null ? addresses[0].phone?.phoneNumber : '',
          extension: addresses[0].phone?.phoneNumber != null ? addresses[0].phone?.extension : '',
          displayOrder: addresses[0].phone?.displayOrder != null ? addresses[0].phone?.displayOrder : 0
        },
        primaryAddress: addresses[0].primaryAddress,
        secondaryAddress: addresses[0].secondaryAddress,
        displayOrder: addresses[0].displayOrder
      }
    }
  } catch (error) {
    console.log('Error Loading Default Org Address')
  }

  return {
    phone: null,
    primaryAddress: {
      addressOne: '',
      addressTwo: '',
      city: '',
      id: undefined,
      mailingAddress: true,
      country: {
        id: 0,
        country_desc: 'Global',
        country_code: '',
        states: []
      },
      postalCode: '',
      state: null
    },
    secondaryAddress: {
      addressOne: '',
      addressTwo: '',
      city: '',
      id: undefined,
      mailingAddress: false,
      postalCode: '',
      state: null,
      country: {
        id: 0,
        country_desc: 'Global',
        country_code: '',
        states: []
      }
    }
  }
}

export const newPosition = async (orgId: number): Promise<Position> => {
  const [orgInfo, orgAddressInfo] = await Promise.all([
    getOrgBasicInfo(orgId),
    getAddressFromOrg(orgId)
  ])
  const countryId = orgInfo.country?.id

  const positionObject: Position = {
    regionId: null,
    updatedBy: undefined,
    address: orgAddressInfo,
    displayOrder: 0,
    id: 0,
    lastUpdated: '',
    organization: { id: orgId },
    person: { firstName: '', lastName: '' },
    title: '',
    titleLocal: '',
    typeId: null
  }

  if (typeof countryId === 'number' && countryId > 0) {
    positionObject.countryId = countryId
  }

  return positionObject
}

export const isEmptyLastNameAllowed = (customBehaviourValues: CustomBehaviourValues, countryId: number | undefined | null): boolean => {
  if (typeof countryId !== 'number' || countryId === 0 || Array.isArray(customBehaviourValues.custom_behaviours)) {
    return false
  }
  return (
    customBehaviourValues.custom_behaviours
      .get('empty_last_name_allowed')
      ?.ids.includes(countryId) ?? false
  )
}
